/* eslint-disable no-negated-condition */
/* eslint-disable react/jsx-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import 'react-table-6/react-table.css';
import {
  IoMdCheckmark as Check,
  IoMdClose as Remove
} from 'react-icons/io';
import { FormattedMessage } from 'react-intl';
import Link from 'Common/Components/Link/styled';
import DateFormatter from 'Common/Components/DateFormatter/index';
import { TOOL_NAME as TOOL_NAME_SOLAR_WINDS } from 'store/Settings/solarWindsActions';
import { TOOL_NAME as TOOL_NAME_GITLAB } from 'store/Settings/gitLabActions';
import { TOOL_NAME as TOOL_NAME_SERVICE_NOW } from 'store/Settings/serviceNowActions';
import { TOOL_NAME as TOOL_NAME_SERVICE_DESK } from 'store/Settings/serviceDesk/actions';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import FlagIcon from 'Common/Components/FlagIcon';
import { fieldWidths } from 'shared/ui/Table';
import { CheckHeaderVulnAsset } from 'Screens/Contextualization/Host/components/HostVulnerabilities/VulnsTable/Table/CheckHeaderVulnAsset /CheckHeaderVulnAsset ';
import { CheckColumVulnAsset } from 'Screens/Contextualization/Host/components/HostVulnerabilities/VulnsTable/Table/CheckColumVulnAsset/CheckColumVulnAsset';
import NameCellVulnAsset from 'Screens/Contextualization/Host/components/HostVulnerabilities/VulnsTable/Table/NameCellVulnAsset ';
import {
  DraggableCheckColum, CheckHeader, Confirm,
  Severity, Expander, SeverityHeader, TagCell, CVE, CWE, CVSS,
  Impact, GenericCell, Risk, StatusCell
} from './columns';
import StatusTraceCell from './columns/StatusTraceCell';
import Name from './columns/Name';

// Same derived flags the legacy getColumns computed once per build.
const isDetailExtended = ({ showVulnDetail, currentBreakpoint }) => (showVulnDetail && currentBreakpoint === 'second');
const getShowSkeleton = ({ isFetching, isFetchingExpandedData, isPivot, hasGroupedData }) => isFetching || (isFetchingExpandedData && !isPivot && !hasGroupedData);
const getEntity = ({ vulnsAssetTable }) => (vulnsAssetTable ? 'vulnsAssets' : 'vulns');

const notGrouped = ({ groupBy }) => !groupBy;
const fieldOrder = (fieldKey) => ({ fields }) => fields[fieldKey]?.order;
// `fields.x?.visible && !(showVulnDetail && currentBreakpoint === 'second')`, same falsy values as legacy.
const visibleUnlessDetail = (fieldKey) => (ctx) => ctx.fields[fieldKey]?.visible && !isDetailExtended(ctx);
const minWidthProps = (fieldKey) => (rowInfo, { fields }) => ({ className: `min-wd-${fields[fieldKey]?.defaultMin}` });
const minWidthThemedProps = (fieldKey) => (rowInfo, { fields, theme }) => ({ className: `min-wd-${fields[fieldKey]?.defaultMin}`, style: { color: theme.text.tableVulnName } });
// eslint-disable-next-line react/display-name
const genericCell = (attrib, extraProps = {}) => (rowInfo, ctx) => <GenericCell showSkeleton={ getShowSkeleton(ctx) } rowInfo={ rowInfo } attrib={ attrib } { ...extraProps } />;

/**
 * Plain detail column: `fields[fieldKey]` drives visibility/order/widths, hidden while the detail
 * is open on the 'second' breakpoint, resizable only without group by.
 */
const detailColumn = (fieldKey, column) => ({
  visible: visibleUnlessDetail(fieldKey),
  resizable: notGrouped,
  ...fieldWidths(fieldKey, { groupAware: true }),
  order: fieldOrder(fieldKey),
  ...column
});

const renderIssueTracker = (rowInfo) => {
  if (isEmpty(rowInfo.original.issuetracker)) return null;
  let issueTracker = '';
  const issueTrackerJson = rowInfo.original.issuetracker;

  if (issueTrackerJson.whd) issueTracker = TOOL_NAME_SOLAR_WINDS;
  if (issueTrackerJson.gitlab) issueTracker = TOOL_NAME_GITLAB;
  if (issueTrackerJson.servicenow) issueTracker = TOOL_NAME_SERVICE_NOW;
  if (issueTrackerJson.mesd) issueTracker = TOOL_NAME_SERVICE_DESK;
  if (issueTrackerJson.jira) {
    return issueTrackerJson.jira.map((issue) => {
      const id = (issue.tool_id ?? issue.key)?.toUpperCase();

      return (
        <Link key={ id } target="_blank" href={ issue.url }>
          {id},{' '}
        </Link>
      );
    });
  }
  if (issueTrackerJson && issueTracker && issueTrackerJson[issueTracker].length) {
    return <Link target="_blank" href={ issueTrackerJson[issueTracker][0].url }>{issueTracker.toUpperCase()}</Link>;
  } else if (issueTrackerJson && issueTracker && issueTrackerJson[issueTracker]) {
    return <Link target="_blank" href={ issueTrackerJson[issueTracker].url }>{issueTracker.toUpperCase()}</Link>;
  }
  return null;
};

const baseColumns = [
  {
    headerStyle: { display: 'none' },
    id: 'expander',
    visible: ({ groupBy, isPivot }) => !!(groupBy && isPivot),
    sortable: false,
    filterable: false,
    maxWidth: 50,
    minWidth: 50,
    order: -1,
    style: ({ isFetching }) => ({ display: isFetching ? 'none' : '' }),
    expander: ({ isExpanded, original }, { isFetching, groupBy }) => <Expander isFetching={ isFetching } isExpanded={ !!isExpanded } original={ original } group_by={ groupBy } />
  }, {
    header: (headerInfo, { vulnsAssetTable, groupBy, isPivot }) => (vulnsAssetTable ? <CheckHeaderVulnAsset /> : ((!groupBy || !isPivot) && <CheckHeader />)),
    id: 'selected',
    accessor: 'Selected',
    visible: true,
    sortable: false,
    resizable: false,
    maxWidth: 55,
    minWidth: 55,
    headerStyle: { overflow: 'visible' },
    style: { display: 'flex' },
    skeleton: false,
    cell: (rowInfo, ctx) => {
      const { vulnsAssetTable, showQuickPlanner, groupBy, isPivot, isFetchingExpandedData, hasGroupedData } = ctx;
      const showSkeleton = getShowSkeleton(ctx);
      if (vulnsAssetTable && !showQuickPlanner) return <CheckColumVulnAsset vuln={ rowInfo.original } showSkeleton={ showSkeleton } />;
      else if (vulnsAssetTable && showQuickPlanner) return <DraggableCheckColum vuln={ rowInfo.original } />;
      else if (!vulnsAssetTable && ((!groupBy || !isPivot) && (!isFetchingExpandedData || hasGroupedData))) return <DraggableCheckColum vuln={ rowInfo.original } showSkeleton={ showSkeleton } />;
      else return null;
    }
  }, {
    header: () => <SeverityHeader />,
    showSortIcon: false,
    headerStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    id: 'severity',
    accessor: 'severity',
    visible: ({ fields, groupBy }) => fields.severity?.visible && (!groupBy || groupBy !== 'severity'),
    sortable: notGrouped,
    resizable: false,
    maxWidth: 45,
    minWidth: 45,
    cellProps: () => ({ style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } }),
    cell: (rowInfo, ctx) => (!ctx.isPivot || !ctx.groupBy) && <Severity vuln={ rowInfo.original } />,
    order: fieldOrder('severity')
  }, {
    header: () => <FlagIcon title="Confirmed / Not Confirmed" theme="allVulns" />,
    showSortIcon: false,
    id: 'confirmed',
    accessor: 'confirmed',
    visible: ({ fields }) => fields.confirmed?.visible,
    sortable: notGrouped,
    resizable: false,
    maxWidth: 45,
    minWidth: 45,
    cell: (rowInfo, ctx) => (!ctx.isPivot || !ctx.groupBy) && <Confirm vuln={ rowInfo.original } entity={ getEntity(ctx) } />,
    order: fieldOrder('confirmed')
  }, {
    header: () => <div children="NAME" />,
    id: 'name',
    accessor: 'name',
    visible: ({ fields }) => fields.name?.visible,
    sortable: notGrouped,
    resizable: notGrouped,
    ...fieldWidths('name', { groupAware: true }),
    // The legacy table compared the row index with react-table's `state.selected`, a key the engine
    // never sets (it always read the 0 default): the first row never gets `column_name`.
    cellProps: (rowInfo, ctx) => {
      const { fields } = ctx;
      const extendFieldName = isDetailExtended(ctx);
      const index = get(rowInfo, 'index', 0);
      if (index !== 0) return ({ className: `column_name min-wd-${fields.name?.defaultMin} ${extendFieldName ? '' : `max-wd-${fields.name?.maxWidth}`}` });
      return ({ className: `min-wd-${fields.name?.defaultMin} ${extendFieldName ? '' : `max-wd-${fields.name?.maxWidth}`}` });
    },
    order: fieldOrder('name'),
    skeleton: false,
    cell: (rowInfo, ctx) => (ctx.vulnsAssetTable ? <NameCellVulnAsset rowInfo={ rowInfo.original } showSkeleton={ getShowSkeleton(ctx) } /> : <Name showSkeleton={ getShowSkeleton(ctx) } groupBy={ ctx.groupBy } isPivot={ ctx.isPivot } vuln={ rowInfo.original } entity={ getEntity(ctx) } />)
  }, {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.service" />
      </div>
    ),
    ...fieldWidths('service__name', { groupAware: true }),
    sortable: notGrouped,
    resizable: notGrouped,
    id: 'service__name',
    visible: (ctx) => ctx.fields.service__name?.visible && !isDetailExtended(ctx) && !ctx.groupBy,
    cell: (rowInfo) => (
      rowInfo.original.service ? `(${rowInfo.original.service.ports}/${rowInfo.original.service.protocol}) ${rowInfo.original.service.name}` : ''
    ),
    cellProps: minWidthThemedProps('service__name'),
    order: fieldOrder('service__name')
  }, {
    header: () => <div children="ASSET" />,
    id: 'target',
    accessor: 'asset',
    visible: (ctx) => !ctx.vulnsAssetTable && ctx.fields.asset?.visible && !isDetailExtended(ctx) && ctx.groupBy !== 'cve_instances__name',
    sortable: notGrouped,
    resizable: notGrouped,
    maxWidth: ({ vulnsAssetTable, groupBy, fields }) => (vulnsAssetTable ? 0 : groupBy ? fields.asset?.defaultMin : fields.asset?.maxWidth),
    minWidth: ({ vulnsAssetTable, fields }) => (vulnsAssetTable ? 0 : fields.asset?.minWidth),
    // Legacy compared `rowInfo.index !== state.selected`, always true (the engine never sets it).
    cellProps: (rowInfo, { vulnsAssetTable, fields, theme }) => (!vulnsAssetTable ? { className: `column_target min-wd-${fields.asset?.defaultMin}`, style: { color: theme.text.tableVulnName } } : ''),
    order: ({ vulnsAssetTable, fields }) => (vulnsAssetTable ? -1 : fields.asset?.order),
    skeleton: false,
    cell: genericCell('target')
  }, {
    header: () => <div children="RISK SCORE" />,
    id: 'risk',
    accessor: 'risk',
    visible: (ctx) => ctx.fields.risk?.visible && !isDetailExtended(ctx) && ctx.isAllowedByLicense && !ctx.groupBy,
    sortable: notGrouped,
    resizable: notGrouped,
    ...fieldWidths('risk', { groupAware: true }),
    cellProps: minWidthProps('risk'),
    order: fieldOrder('risk'),
    skeleton: false,
    cell: (rowInfo, ctx) => <Risk showSkeleton={ getShowSkeleton(ctx) } vuln={ rowInfo.original } />
  }, {
    header: () => <div children="CVSS" />,
    id: 'cvss',
    accessor: 'cvss',
    // community fork: CVSS also requires isAllowedByLicense here (see community-overrides/files
    // in professional for the professional/dev fork of this file).
    visible: (ctx) => ctx.fields.cvss?.visible && !isDetailExtended(ctx) && !ctx.groupBy && ctx.isAllowedByLicense,
    sortable: false,
    resizable: notGrouped,
    ...fieldWidths('cvss', { groupAware: true }),
    order: fieldOrder('cvss'),
    skeleton: false,
    cell: (rowInfo, ctx) => {
      if (!rowInfo.original.cvss4 && !rowInfo.original.cvss3 && !rowInfo.original.cvss2) return null;
      return <CVSS vuln={ rowInfo.original } showSkeleton={ getShowSkeleton(ctx) } />;
    },
    cellProps: minWidthThemedProps('cvss')
  }, {
    header: () => <div children="STATUS TRACE" />,
    id: 'status_history',
    accessor: 'status_history',
    visible: (ctx) => ctx.fields.status_history?.visible && !isDetailExtended(ctx) && !ctx.groupBy,
    sortable: false,
    resizable: notGrouped,
    ...fieldWidths('status_history', { groupAware: true }),
    order: fieldOrder('status_history'),
    skeleton: false,
    cell: (rowInfo, ctx) => <StatusTraceCell vuln={ rowInfo.original } showSkeleton={ getShowSkeleton(ctx) } entity={ getEntity(ctx) } />,
    cellProps: minWidthThemedProps('status_history')
  },
  detailColumn('cve', {
    header: () => <div children="CVE" />,
    id: 'cve',
    accessor: 'cve',
    sortable: false,
    skeleton: false,
    cell: (rowInfo, ctx) => (
      <CVE
        showSkeleton={ getShowSkeleton(ctx) }
        vuln={ rowInfo.original }
        entity={ getEntity(ctx) }
      />
    ),
    cellProps: minWidthThemedProps('cve')
  }),
  detailColumn('cwe', {
    header: () => <div children="CWE" />,
    id: 'cwe',
    accessor: 'cwe',
    sortable: false,
    skeleton: false,
    cell: (rowInfo, ctx) => <CWE showSkeleton={ getShowSkeleton(ctx) } vuln={ rowInfo.original } isFetching={ ctx.isFetching } />,
    cellProps: minWidthThemedProps('cwe')
  }),
  {
    header: () => <div children="OWASP" />,
    id: 'owasp',
    accessor: 'owasp',
    visible: (ctx) => ctx.fields.owasp?.visible && !isDetailExtended(ctx) && ctx.isAllowedByLicense && !ctx.groupBy,
    sortable: false,
    resizable: notGrouped,
    ...fieldWidths('owasp', { groupAware: true }),
    order: fieldOrder('owasp'),
    skeleton: false,
    cell: (rowInfo) => {
      if (!rowInfo.original.owasp) return <span />;
      return <>{rowInfo.original.owasp.map(el => (<>{el} </>))}</>;
    },
    cellProps: minWidthThemedProps('owasp')
  },
  detailColumn('tags', {
    header: () => <div><FormattedMessage id="manage.table.columns.tags" /></div>,
    accessor: 'tags',
    sortable: false,
    visible: (ctx) => visibleUnlessDetail('tags')(ctx) && ctx.isTagsAllowedByLicense,
    // Legacy: the min width comes from `maxWidth` (kept as is).
    minWidth: ({ fields }) => fields.tags?.maxWidth,
    id: 'tags',
    cell: (rowInfo, ctx) => <TagCell rowInfo={ rowInfo } showSkeleton={ getShowSkeleton(ctx) } onAsset={ ctx.vulnsAssetTable } />,
    cellProps: (rowInfo, { fields, theme }) => ({ 'column-type': 'tags', 'className': `min-wd-${fields.tags?.defaultMin}`, 'style': { color: theme.text.tableVulnName } })
  }),
  detailColumn('id', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.id" />
      </div>
    ),
    id: 'id',
    accessor: '_id',
    sortable: notGrouped,
    cellProps: minWidthThemedProps('id'),
    skeleton: false,
    cell: genericCell('obj_id')
  }),
  detailColumn('host__os', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.host_os" />
      </div>
    ),
    id: 'host__os',
    accessor: 'host_os',
    sortable: notGrouped,
    cellProps: minWidthProps('host__os'),
    skeleton: false,
    cell: genericCell('host_os')
  }),
  detailColumn('easeofresolution', {
    header: () => <div children="EASE OF RESOLUTION" />,
    id: 'easeofresolution',
    accessor: 'easeofresolution',
    sortable: notGrouped,
    cellProps: minWidthProps('easeofresolution'),
    skeleton: false,
    cell: genericCell('easeofresolution', { capitalize: true })
  }),
  detailColumn('website', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.website" />
      </div>
    ),
    id: 'website',
    accessor: 'website',
    sortable: false,
    cellProps: minWidthProps('website'),
    skeleton: false,
    cell: genericCell('website')
  }),
  detailColumn('path', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.path" />
      </div>
    ),
    id: 'path',
    accessor: 'path',
    sortable: false,
    cellProps: minWidthProps('path'),
    skeleton: false,
    cell: genericCell('path')
  }),
  detailColumn('status_code', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.status_code" />
      </div>
    ),
    id: 'status_code',
    accessor: 'status_code',
    sortable: notGrouped,
    cellProps: minWidthProps('status_code'),
    skeleton: false,
    cell: genericCell('status_code')
  }),
  detailColumn('hostnames', {
    header: () => <div children="HOSTNAMES" />,
    id: 'hostnames',
    accessor: 'hostnames',
    sortable: false,
    cell: (rowInfo) => {
      const hostnames = get(rowInfo, 'original.hostnames', []);
      return <div className="three-dots">{hostnames.join(', ')}</div>;
    },
    cellProps: minWidthThemedProps('hostnames')
  }),
  detailColumn('impact', {
    header: () => <div><FormattedMessage id="manage.table.columns.impact" /></div>,
    id: 'impact',
    sortable: false,
    skeleton: false,
    cell: (rowInfo, ctx) => <Impact showSkeleton={ getShowSkeleton(ctx) } rowInfo={ rowInfo } />,
    cellProps: minWidthThemedProps('impact')
  }),
  detailColumn('description', {
    header: () => <div><FormattedMessage id="manage.table.columns.description" /></div>,
    id: 'description',
    accessor: 'description',
    sortable: false,
    cellProps: minWidthProps('description'),
    skeleton: false,
    cell: genericCell('description')
  }),
  detailColumn('data', {
    header: () => <div><FormattedMessage id="manage.table.columns.data" /></div>,
    id: 'data',
    accessor: 'data',
    sortable: false,
    cellProps: minWidthProps('data'),
    skeleton: false,
    cell: genericCell('data')
  }),
  detailColumn('request', {
    header: () => <div><FormattedMessage id="manage.table.columns.request" /></div>,
    id: 'request',
    accessor: 'request',
    sortable: false,
    cellProps: minWidthProps('request'),
    skeleton: false,
    cell: genericCell('request')
  }),
  detailColumn('response', {
    header: () => <div><FormattedMessage id="manage.table.columns.response" /></div>,
    id: 'response',
    accessor: 'response',
    sortable: false,
    cellProps: minWidthProps('response'),
    skeleton: false,
    cell: genericCell('response')
  }),
  detailColumn('resolution', {
    header: () => <div><FormattedMessage id="manage.table.columns.resolution" /></div>,
    id: 'resolution',
    accessor: 'resolution',
    sortable: false,
    cellProps: minWidthProps('resolution'),
    skeleton: false,
    cell: genericCell('resolution')
  }),
  detailColumn('method', {
    header: () => <div><FormattedMessage id="manage.table.columns.method" /></div>,
    id: 'method',
    accessor: 'method',
    sortable: false,
    cellProps: minWidthProps('method'),
    skeleton: false,
    cell: genericCell('method')
  }),
  detailColumn('query', {
    header: () => <div children="QUERY" />,
    id: 'query',
    accessor: 'query',
    sortable: false,
    cellProps: minWidthProps('query'),
    skeleton: false,
    cell: genericCell('query')
  }),
  detailColumn('evidence', {
    header: () => <div><FormattedMessage id="manage.table.columns.evidence" /></div>,
    id: 'evidence',
    accessor: 'evidence',
    sortable: false,
    cellProps: minWidthProps('evidence'),
    skeleton: false,
    cell: genericCell('attachments_count')
  }),
  // Legacy: the "type" column reads `fields.web`.
  detailColumn('web', {
    header: () => <div children="WEB" />,
    id: 'type',
    accessor: 'web',
    sortable: notGrouped,
    cell: (rowInfo, ctx) => {
      if (ctx.groupBy) return null;
      if (rowInfo.original.type === 'VulnerabilityWeb') return <Check />;
      return <Remove />;
    },
    cellProps: minWidthThemedProps('web')
  }),
  detailColumn('tool', {
    header: () => <div><FormattedMessage id="manage.table.columns.tool" /></div>,
    id: 'tool',
    accessor: 'metadata.tool',
    sortable: notGrouped,
    cellProps: minWidthProps('tool'),
    skeleton: false,
    cell: genericCell('tool')
  }),
  detailColumn('creator_command_id', {
    header: () => <div><FormattedMessage id="manage.table.columns.command_id" /></div>,
    id: 'creator_command_id',
    accessor: 'metadata.command_id',
    sortable: notGrouped,
    cellProps: minWidthProps('creator_command_id'),
    skeleton: false,
    cell: genericCell('metadata.command_id')
  }),
  detailColumn('external_id', {
    header: () => <div children="EXTERNAL ID" />,
    id: 'external_id',
    accessor: 'external_id',
    sortable: notGrouped,
    cellProps: minWidthProps('external_id'),
    skeleton: false,
    cell: genericCell('external_id')
  }),
  detailColumn('create_date', {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.date" />
      </div>
    ),
    id: 'create_date',
    sortable: notGrouped,
    cell: (rowInfo) => (rowInfo.original.date ? <DateFormatter date={ rowInfo.original.date } /> : null),
    cellProps: minWidthThemedProps('create_date')
  }),
  {
    header: () => (
      <div>
        <FormattedMessage id="manage.table.columns.issueTracker" />
      </div>
    ),
    id: 'issuetracker',
    resizable: notGrouped,
    // Legacy: not hidden by the vuln detail breakpoint and no `sortable` (engine default).
    visible: ({ fields }) => fields.issuetracker?.visible,
    ...fieldWidths('issuetracker', { groupAware: true }),
    skeleton: false,
    cell: renderIssueTracker,
    order: fieldOrder('issuetracker'),
    cellProps: minWidthThemedProps('issuetracker')
  },
  detailColumn('update_date', {
    header: () => <div children="Updated" />,
    id: 'update_date',
    sortable: notGrouped,
    cell: (rowInfo) => {
      const updateTime = get(rowInfo, 'original.metadata.update_time', null);
      if (!updateTime) return null;
      return <DateFormatter date={ updateTime } />;
    },
    cellProps: minWidthThemedProps('update_date')
  }),
  detailColumn('status', {
    header: (headerInfo, { fields }) => (
      <div className={ `min-wd-${fields.status?.defaultMin}` }>
        <FormattedMessage id="manage.table.columns.status" />
      </div>
    ),
    id: 'status',
    accessor: 'status',
    visible: (ctx) => ctx.fields.status?.visible && !isDetailExtended(ctx) && (!ctx.groupBy || ctx.groupBy !== 'status'),
    sortable: notGrouped,
    skeleton: false,
    cell: (rowInfo, ctx) => <StatusCell showSkeleton={ getShowSkeleton(ctx) } rowInfo={ rowInfo } attrib="status" capitalize />,
    cellProps: (rowInfo, { fields }) => (rowInfo.original.status === 'open' ? { 'className': `open min-wd-${fields.status?.defaultMin}`, 'column-type': 'status' } : { 'className': `${rowInfo.original.status} min-wd-${fields.status?.defaultMin}`, 'column-type': 'status' })
  }),
  detailColumn('last_detected', {
    header: () => <div children="Last Detected" />,
    id: 'last_detected',
    sortable: notGrouped,
    cell: (rowInfo) => (rowInfo.original.last_detected ? <DateFormatter date={ moment.utc(rowInfo.original?.last_detected).local() } /> : null),
    cellProps: minWidthThemedProps('last_detected')
  })
];

// Custom attribute columns, appended after the base ones exactly like the legacy getColumns.
const getCustomFieldColumns = (ctx) => {
  const { customFields, fields } = ctx;
  if (!customFields) return [];

  return customFields.reduce((acc, cf) => {
    const key = `${cf.field_display_name}_custom`;
    const defaultFieldMeta = fields[cf.field_name];
    const fieldMeta = fields[key];

    if (!fieldMeta) return acc;

    const showCustom = fieldMeta.visible && !isDetailExtended(ctx);
    const defaultVisible = defaultFieldMeta?.visible;

    if (showCustom && (!defaultVisible || (defaultVisible && showCustom))) {
      acc.push({
        header: () => <div>{cf.field_display_name.toUpperCase()}</div>,
        id: key,
        accessor: row => row.custom_fields?.[cf.field_name] ?? '',
        visible: true,
        sortable: false,
        resizable: false,
        maxWidth: 200,
        minWidth: 200,
        order: fieldMeta.order,
        cell: (rowInfo) => <p>{rowInfo.value}</p>
      });
    }
    return acc;
  }, []);
};

/**
 * Vulnerabilities table of Manage (main table, group-by sub table) and of the asset detail
 * (HostVulnerabilities, with `vulnsAssetTable: true`).
 *
 * ctx:
 * - `isPivot` {boolean} true on the main table, false on the group-by sub table
 * - `customFields` {Object[]} custom attributes (`selectCustomAttributes`)
 * - `showVulnDetail` {boolean}
 * - `currentBreakpoint` {string} 'second' + `showVulnDetail` hides most columns
 * - `groupBy` {string|false|null} group by field ('severity', 'status', 'cve_instances__name'…)
 * - `fields` {Object} column preferences (`selectManageFields` / `selectVulnsAssetFields`)
 * - `isFetching` {boolean}
 * - `isFetchingExpandedData` {boolean}
 * - `hasGroupedData` {boolean|null} sub table only
 * - `isAllowedByLicense` {boolean} risk score / OWASP columns
 * - `vulnsAssetTable` {boolean} asset detail table (asset column hidden, own check cells)
 * - `showQuickPlanner` {boolean}
 * - `theme` {Object} theme styles (`useTheme().themeStyles`)
 */
const manageVulnsSchema = {
  id: 'manageVulns',
  // Cells that render their own skeleton (`showSkeleton` prop) or none opt out with `skeleton: false`.
  loading: { skeleton: getShowSkeleton },
  ordering: {},
  normalizeWidths: true,
  columns: (ctx) => [...baseColumns, ...getCustomFieldColumns(ctx)]
};

export default manageVulnsSchema;
